<script>
import Icons from "@/components/Icons.vue";
import Button from "@/components/form/Button.vue";
import CardBuscar from "@/components/CardBuscar.vue";

export default {
  components: {
    Button,
    CardBuscar,
    Icons,
  },
  data() {
    return {
      aux: import.meta.env.VITE_BASE_PATH,
      tagName: "",
      limit: 4,
      ofertas: [],
      tutoriais: [],
      lancamentos: [],
      experiencias: [],
      dicas: [],
    };
  },
  mounted() {
    this.tagName = this.$route.params?.tagName;
    //console.log(this.$route)
    if (this.tagName) this.loadContents(null, this.tagName);
  },
  methods: {
    loadContents(search = null, tag = null) {
      const filters = {
        tag,
        search,
        limit: this.limit,
      };
      this.$store.dispatch("contents/get", filters).then((response) => {
        const { data: data = {} } = response;
        const { rows: rows = [] } = data;

        const tutoriaisAux = rows.filter((row) => row.hasOwnProperty('tutorials'));
        this.tutoriais = tutoriaisAux.map((tutorial) => ({
          ...tutorial,
          tutorial: tutorial.tutorials[0],
          type: "tutorial",
        }));

        const ofertasAux = rows.filter((row) => row.hasOwnProperty('saleOffers'));
        this.ofertas = ofertasAux.map((oferta) => ({
          ...oferta,
          saleOffer: oferta.saleOffers[0],
          type: "saleOffer",
        }));

        const lancamentosAux = rows.filter((row) => row.hasOwnProperty('productLaunches'));
        this.lancamentos = lancamentosAux.map((lancamento) => ({
          ...lancamento,
          productLaunch: lancamento.productLaunches[0],
          type: "productLaunch",
        }));

        const experienciaAux = rows.filter((row) => row.hasOwnProperty('exclusiveExperiences'));
        this.experiencias = experienciaAux.map((exp) => ({
          ...exp,
          exclusiveExperience: exp.exclusiveExperiences[0],
          type: "exclusiveExperience",
        }));
      });
    },
    filterContent(search) {
      this.loadContents(search);
    },
  },
};
</script>

<template>
  <div class="wrapper buscar">
    <div class="text-center search-wrapper">
      <div class="search-wrapperMain">
        <input @input="filterContent($event.target.value)" type="text" />
        <Icons name="search" />
      </div>
      <!-- <div class="contentActiveTag">
		<h5 class="contentActiveTag--title">Busca selecionada:</h5> <span class="tagBuscar">Nome da tag <Icons name="xMark"/></span>	 <span class="tagBuscar">Nome da tag <Icons name="xMark"/></span>		
	</div> -->
    </div>

    <section v-if="ofertas && ofertas.length > 0 && aux !== '/mx/' && aux !== '/br/' && aux !== '/pa/'">
      <h1>{{ $t("buscar.ofertas") }}</h1>
      <div class="cards">
        <CardBuscar
          v-for="(card, index) in ofertas"
          small
          :data="card"
          :key="index"
        />
      </div>
    </section>

    <section v-if="lancamentos && lancamentos.length > 0">
      <h1>{{ $t("buscar.lancamentos") }}</h1>
      <div class="cards">
        <CardBuscar
          v-for="(card, index) in lancamentos"
          small
          :data="card"
          :key="index"
        />
      </div>
    </section>

    <section v-if="experiencias && experiencias.length > 0">
      <h1>{{ $t("buscar.experiencia") }}</h1>
      <div class="cards">
        <CardBuscar
          v-for="(card, index) in experiencias"
          small
          :data="card"
          :key="index"
        />
      </div>
    </section>

    <section v-if="tutoriais && tutoriais.length > 0">
      <h1>{{ $t("buscar.tutoriais") }}</h1>
      <div class="cards">
        <CardBuscar
          v-for="(card, index) in tutoriais"
          small
          :data="card"
          :key="index"
        />
      </div>
    </section>
  </div>
</template>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *

h1
	color: #474642
	font-weight: 600
	font-size: 1.75rem
	margin-bottom: 40px

.buscar
	--contentSize: 1195px
	--sizeCard: 270px
	@include container-wrapper (1195px)
	margin-top: 25px
	gap: 20px

	.search-wrapper
		display: flex
		align-items: center
		justify-content: center
		padding: 14px 14px
		flex-direction: column

		.search-wrapperMain
			display: flex
			align-items: center
			justify-content: center
			gap: 20px
			margin: 0 auto 10px


			input
				background-color: #fff
				border: 1px solid #716f6a
				font-size: 28px
				border-radius: 2.5rem
				height: 65px
				width: calc(100% - 48px)
				padding: 0 40px
				flex: 1


			i, svg
				display: block
				width: 2.375rem
				height: 2.375rem

			+respond-to($breakpoint-sm-min)

				input
					width: 720px

	section:not(:last-child)
		padding: 14px 14px 60px
		// border-bottom: 2px solid #716f6a

		+respond-to($breakpoint-sm-min)
			padding: 0px 0px 60px

	.cards
		display: grid
		grid-auto-columns: 1fr
		grid-template-columns: repeat(auto-fill, minmax(var(--sizeCard), 1fr))
		grid-template-rows: 1fr
		gap: 30px


		+respond-to($breakpoint-sm-min)
			padding: 0px
			grid-auto-flow: row
			padding-inline: 0
			--sizeCard: 270px


.contentActiveTag
	width: 100%
	max-width: 600px
	display: flex
	flex-direction: row
	flex-wrap: wrap
	gap: 10px


	.contentActiveTag--title
		font-weight: 600
		font-size: 1rem

.tagBuscar
	display: flex
	flex-direction: row
	gap: 5px
	align-items: center
	border-radius: 9999px
	padding: 4px 16px !important
	font-size: 12px
	color: var(--white)
	background-color: var(--color-grey-1500)

	i
		display: inline-block
		width: 1rem !important
		height: 1rem !important
		color: var(--white)
		cursor: pointer
</style>
